import React from "react";

import type { ActivityAttachment } from "../types/reviewTypes";
import useAttachmentDownload from "../hooks/useAttachmentDownload";
import AttachmentsTab from "./AttachmentsTab";
import PanelTabs from "./PanelTabs";

interface ActivityPanelTabsProps {
  attachments?: ActivityAttachment[];
  children: React.ReactNode;
}

function ActivityPanelTabs({ attachments, children }: ActivityPanelTabsProps) {
  const normalizedAttachments = attachments ?? [];
  const { downloadOne, openOne, downloadAll, isDownloadingAll, isAttachmentBusy } = useAttachmentDownload();

  if (normalizedAttachments.length === 0) {
    return <>{children}</>;
  }

  return (
    <PanelTabs
      attachmentsCount={normalizedAttachments.length}
      reviewContent={children}
      attachmentsContent={
        <AttachmentsTab
          attachments={normalizedAttachments}
          isDownloadingAll={isDownloadingAll}
          isAttachmentBusy={isAttachmentBusy}
          onDownload={downloadOne}
          onOpen={openOne}
          onDownloadAll={downloadAll}
        />
      }
    />
  );
}

export default ActivityPanelTabs;
